// TODO: these zIndex values are summed up with the 400 zIndex base for a Pane. This is confusing and evens conflictgs when a layer is not added to the layer manager
export const Z_INDEX = {
  // default leaflet elements
  markerPane: 1500,
  popupPane: 1501,

  // custom panes
  emissions: 400,
  results: 500,
  activeSegment: 500,
  activePointSource: 505,
  scenarioTrafficWithBarrier: 510,
  selectionPreview: 520,
};
